export default __webpack_public_path__ + "static/icon-style-e487e1f283d605b783b303bef1cf6eb6.svg";